export const COMPANY_REFERENCE_TABLE = '/company/reference-table'
export const COMPANY_DISEASES = '/company/diseases'

export const COMPANY_REFERENCE_TYPES_BY_NUMBERS: Map<number, string> = new Map([
  [1, 'phones'],
  [2, 'emails'],
  [3, 'addresses'],
  [4, 'programDischargeReasons'],
  [6, 'relationship'],
  [7, 'medicalSpecialties'],
  [8, 'genders'],
  [9, 'patientGroups'],
  [10, 'languages'],
  [11, 'activityTypes'],
  [12, 'auditLogTimer'],
  [13, 'education'],
  [14, 'checkIn'],
  [15, 'measurement'],
  [16, 'chat'],
  [18, 'broadcastCategoryList'],
  [20, 'eventTypes'],
  [21, 'backfillMedication'],
  [22, 'enrollProgramType'],
  [23, 'medicationSkipReason'],
  [24, 'carePlanResponsible'],
  [25, 'backfillCarePlan'],
  [26, 'patientProvider'],
  [27, 'patientInsurance'],
  [28, 'medicalDevices'],
  [29, 'prognosis'],
  [30, 'telemedicine'],
  [31, 'riskLevel'],
  [32, 'emergencyPreparednessRiskLevel'],
  [33, 'modeOfTransportation'],
  [34, 'externalDocumentType'],
  [35, 'patientHoldReason'],
  [36, 'alertQuickCloseReasons'],
  [38, 'medicalEquipmentStatuses'],
  [39, 'medicalEquipmentCategories'],
  [40, 'medicalDeviceTrainingStatus'],
  [41, 'medicalDeviceShipmentStatus'],
  [42, 'telemedicineCallType'],
  [43, 'taskStatus'],
  [44, 'taskType'],
  [45, 'urgentCareOutcome'],
  [46, 'telemedicineCallOutcome'],
  [47, 'taskAction'],
  [48, 'refuseServiceReasons'],
  [49, 'referralReasons'],
  [50, 'referralOutreachStatuses'],
  [51, 'actionNotification'],
  [52, 'preventiveTypes'],
  [59, 'appointmentStatuses'],
  [65, 'accountManager']
])
